import { usePropertyContactPhone } from '../../../../../queries/PropertyFields/NonRentalContactFields';
import { PhoneBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { formatPhone } from '@apply/ui';

interface OnsitePropertyContactPhoneProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const OnsitePropertyContactPhone: React.FC<OnsitePropertyContactPhoneProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const label = 'Phone';
    const [onsitePropertyContactPhone, set_onsitePropertyContactPhone] = usePropertyContactPhone(propertyGuid);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={`Contact ${label}`}
                    value={formatPhone(onsitePropertyContactPhone)}
                />
            ) : (
                <PhoneBox
                    id='onsitePropertyContactPhone'
                    value={onsitePropertyContactPhone}
                    onChange={(value) => set_onsitePropertyContactPhone(value)}
                    label={label}
                    required={required}
                    width='100%'
                />
            )}
        </>
    );
};
